import { useRecordContext, Button, useDataProvider, useNotify, useRefresh } from "react-admin";
import { RankingStatus, RankingType } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import React from "react";
import FlagIcon from "@mui/icons-material/Flag";
import { Tooltip, Typography } from "@mui/material";
import ConfirmModal from "server/components/Modals/ConfirmModal";

const GenerateRankingButton = ({ isFinished, hasPaidDraftGenerated }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const status = record?.status;

  if (!record || status === RankingStatus.Approved) {
    return null;
  }

  const isDraft = status === RankingStatus.Draft;
  const isLockedByPaidRanking = hasPaidDraftGenerated && record?.type === RankingType.State;

  // No try/catch: ConfirmModal notifies on error and stays open.
  const generateDraft = async () => {
    await dataProvider.create(candidateRequests.generateCampaignRankingDraft(record.id));
    notify("Успешно изготвено класиране", { type: "success" });
    refresh();
  };

  return (
    <SecuredComponent permission={permissions.canManageCampaignRankings}>
      {/* The Tooltip wraps the whole modal: a disabled trigger fires no events, so the span has to
          catch the hover, and ConfirmModal must keep its own onClick on the Button itself. */}
      <Tooltip
        title={
          isLockedByPaidRanking
            ? "Не може да се преизготви класиране по държавна поръчка след като е изготвено платено класиране"
            : ""
        }
      >
        <span>
          <ConfirmModal
            triggerButton={
              <Button
                label="Изготвяне"
                variant="contained"
                size="medium"
                disabled={isFinished || isLockedByPaidRanking}
              >
                <FlagIcon />
              </Button>
            }
            titleContent={`${isDraft ? "Повторно изготвяне" : "Изготвяне"} на класиране`}
            onConfirm={generateDraft}
            saveTitle="Изготви"
            saveIcon={<FlagIcon />}
            closeTitle="Затвори"
          >
            <Typography sx={{ py: 2 }}>
              {`Сигурни ли сте, че искате да изготвите това класиране${isDraft ? " отново" : ""}?`}
            </Typography>
          </ConfirmModal>
        </span>
      </Tooltip>
    </SecuredComponent>
  );
};

export default GenerateRankingButton;
